import React from 'react'
import { useTranslation } from 'react-i18next'

import { Checkbox } from '@navent-jobs/ui-kit/components/checkbox'

import { ActualizarSalarioCheckboxContainer } from './mixins'

const Component = ({ setActualizarSalario, actualizarSalario }) => {
  const { t } = useTranslation()

  return (
    <ActualizarSalarioCheckboxContainer>
      <Checkbox
        id="actualizar-salario-checkbox"
        name="actualizar-salario-checkbox"
        label={t('fichaAviso.postularBar.actualizarSueldoCV', { cv: t('cv') })}
        onChange={() => {
          setActualizarSalario(!actualizarSalario)
        }}
        fieldOptions={{
          size: 'small',
          defaultChecked: actualizarSalario,
        }}
      />
    </ActualizarSalarioCheckboxContainer>
  )
}

export default Component
